import React from "react";
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from "lucide-react";

const Pagination = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  if (totalPages <= 1) return null;

  // Logika untuk menentukan range nomor halaman yang muncul (Maksimal 5 nomor)
  const getPageNumbers = () => {
    let start = Math.max(1, currentPage - 2);
    let end = Math.min(totalPages, start + 4);

    if (end - start < 4) {
      start = Math.max(1, end - 4);
    }

    const pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  const pages = getPageNumbers();

  // Helper untuk tombol navigasi
  const NavButton = ({ onClick, disabled, children, className = "" }) => (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`p-3 rounded-xl border border-slate-100 dark:border-white/10 bg-white dark:bg-slate-900 text-slate-500 dark:text-slate-400 disabled:opacity-20 disabled:cursor-not-allowed hover:bg-blue-600 hover:text-white hover:border-blue-600 transition-all duration-300 ${className}`}
    >
      {children}
    </button>
  );

  return (
    <div className="flex flex-wrap items-center justify-center gap-2 mt-16 pb-10">
      
      {/* First Page */}
      <NavButton onClick={() => onPageChange(1)} disabled={currentPage === 1}>
        <ChevronsLeft size={18} />
      </NavButton>

      {/* Prev Page */}
      <NavButton onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
        <ChevronLeft size={18} />
      </NavButton>

      {/* Page Numbers (Limit to 5) */}
      <div className="flex items-center gap-2 mx-2">
        {pages.map((page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`w-11 h-11 md:w-12 md:h-12 rounded-xl text-xs font-black transition-all duration-300 ${
              currentPage === page
                ? "bg-blue-600 text-white shadow-xl shadow-blue-600/30 border-blue-600 scale-110 z-10"
                : "bg-white dark:bg-slate-900 border border-slate-100 dark:border-white/10 text-slate-500 hover:border-blue-600 hover:text-blue-600"
            }`}
          >
            {page}
          </button>
        ))}
      </div>

      {/* Next Page */}
      <NavButton onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>
        <ChevronRight size={18} />
      </NavButton>

      {/* Last Page */}
      <NavButton onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages}>
        <ChevronsRight size={18} />
      </NavButton>

    </div>
  );
};

export default Pagination;